import { List, Map } from 'immutable';
export default function resolveDataErrorMessages(err) {
  return List([Map({
    message: err.message
  }) // Just one message for now, but let's make it accommodate for more
  ]);
}